module.exports = __webpack_public_path__ + "static/img/r3.f902c8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/service/r3.png
// module id = 7AHI
// module chunks = 1